module.exports = __webpack_public_path__ + "static/media/import-clients-example.19101c5c.xlsx";